var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1714_4841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.25 2.4375C29.8965 2.4375 30.5165 2.69431 30.9736 3.15143C31.4307 3.60855 31.6875 4.22853 31.6875 4.875V31.0903C31.6875 31.0903 29.25 26.8125 19.5 26.8125C9.75 26.8125 7.3125 31.0903 7.3125 31.0903V4.875C7.3125 4.22853 7.56931 3.60855 8.02643 3.15143C8.48355 2.69431 9.10353 2.4375 9.75 2.4375H29.25ZM9.75 0C8.45707 0 7.21709 0.513615 6.30285 1.42785C5.38861 2.34209 4.875 3.58207 4.875 4.875V34.125C4.875 35.4179 5.38861 36.6579 6.30285 37.5721C7.21709 38.4864 8.45707 39 9.75 39H29.25C30.5429 39 31.7829 38.4864 32.6971 37.5721C33.6114 36.6579 34.125 35.4179 34.125 34.125V4.875C34.125 3.58207 33.6114 2.34209 32.6971 1.42785C31.7829 0.513615 30.5429 0 29.25 0L9.75 0Z",
    fill: "url(#paint0_linear_1714_4841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24.375C20.4603 24.375 21.4112 24.1859 22.2984 23.8184C23.1856 23.4509 23.9917 22.9122 24.6707 22.2332C25.3497 21.5542 25.8884 20.7481 26.2559 19.8609C26.6234 18.9737 26.8125 18.0228 26.8125 17.0625C26.8125 16.1022 26.6234 15.1513 26.2559 14.2641C25.8884 13.3769 25.3497 12.5708 24.6707 11.8918C23.9917 11.2128 23.1856 10.6741 22.2984 10.3066C21.4112 9.93914 20.4603 9.75 19.5 9.75C17.5606 9.75 15.7006 10.5204 14.3293 11.8918C12.9579 13.2631 12.1875 15.1231 12.1875 17.0625C12.1875 19.0019 12.9579 20.8619 14.3293 22.2332C15.7006 23.6046 17.5606 24.375 19.5 24.375Z",
    fill: "url(#paint1_linear_1714_4841)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_4841",
    x1: 4.875,
    y1: -4.875,
    x2: 45.8288,
    y2: 28.7673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1714_4841",
    x1: 12.1875,
    y1: 7.92187,
    x2: 27.7785,
    y2: 24.9986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1714_4841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr4);
export default __webpack_public_path__ + "static/media/Hr4.37e3c5626e826471e66ac02ee42f4177.svg";
export { ForwardRef as ReactComponent };